export default __webpack_public_path__ + "static/media/TAOapp2.0492b05c.png";